import React from 'react';
import { useSelector } from 'react-redux';
import PresenceBadge from '../PresenceBadge';
import { GeckoAvatar, GeckoField, GECKO_CONSTS } from '../../ui';
import './index.scss';
import { sortVisibleAgents } from 'selectors';
import getPresence from 'utilities/getPresence';

export const AgentOption = (props) => {
  return (
    <div className="AgentSelect-AgentOption">
      <PresenceBadge
        presence={getPresence(
          props.presence,
          props.web_available || props.mobile_available
        )}
      >
        <GeckoAvatar
          size={'sm'}
          name={props.full_name}
          color={props.additional.avatar_colour}
          bgImage={props.additional.profile_picture_url}
        />
      </PresenceBadge>
      <span className="avatar-name"> {props.full_name}</span>
    </div>
  );
};

export const AgentSelect = (props) => {
  const agents = useSelector(sortVisibleAgents);

  const renderOption = (option) => {
    return <AgentOption {...option.agent} />;
  };

  const handleChange = (_key, value) => {
    props.onChange(value);
  };

  const field = {
    key: 'value',
    type:
      props.multi === false
        ? GECKO_CONSTS.FIELD_TYPE_SELECT
        : GECKO_CONSTS.FIELD_TYPE_SELECT_MULTI,
    options: agents
      .filter((agent) => !(props.ignore || []).includes(agent.id))
      .map((agent) => {
        return {
          agent: agent,
          label: agent.full_name,
          value: agent.id,
        };
      }),
    optionRenderer: renderOption,
    valueRenderer: renderOption,
    config: props.selectProps || {},
  };
  const values = { value: props.value };
  return (
    <div className="AgentSelect">
      <GeckoField field={field} values={values} handler={handleChange} />
    </div>
  );
};

export default AgentSelect;
